import { X } from 'lucide-react';
import { cn } from '../../lib/cn';
import { useToasts } from '../../stores/toasts';

/** Snackbar en bas à gauche, comme dans Keep. */
export function Toaster() {
  const toasts = useToasts((state) => state.toasts);
  const dismiss = useToasts((state) => state.dismiss);

  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed bottom-4 left-4 z-[70] flex flex-col gap-2 max-sm:right-4"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role={t.variant === 'error' ? 'alert' : 'status'}
          className={cn(
            'animate-slide-up pointer-events-auto flex min-h-12 max-w-[600px] min-w-72 items-center gap-2 rounded py-1.5 pr-2 pl-4 text-sm shadow-dialog',
            'bg-toast text-white dark:text-[#202124]',
            t.variant === 'error' && 'border-l-4 border-danger',
          )}
        >
          <span className="flex-1 py-1.5">{t.message}</span>
          {t.action && (
            <button
              type="button"
              className="rounded px-3 py-2 font-medium text-[#fbbc04] uppercase hover:bg-white/10 dark:text-[#1a73e8] dark:hover:bg-black/10"
              onClick={() => {
                t.action!.onClick();
                dismiss(t.id);
              }}
            >
              {t.action.label}
            </button>
          )}
          <button
            type="button"
            aria-label="Fermer"
            className="rounded-full p-2 opacity-80 hover:bg-white/10 dark:hover:bg-black/10"
            onClick={() => dismiss(t.id)}
          >
            <X size={18} />
          </button>
        </div>
      ))}
    </div>
  );
}
